var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandpostioning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-12,.cls-14,.cls-18,.cls-22,.cls-24,.cls-25,.cls-6{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#d8c4df;}.cls-4{opacity:0.3;}.cls-5{clip-path:url(#clip-path);}.cls-6{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.26px;}.cls-7{fill:#fff;}.cls-27,.cls-8{fill:#2f2143;}.cls-9{fill:#fdc435;}.cls-10{stroke:#2f2143;stroke-width:3.88px;}.cls-10,.cls-11,.cls-12,.cls-14,.cls-18,.cls-22,.cls-24,.cls-25{stroke-miterlimit:10;}.cls-11,.cls-12{stroke:#3a4c69;}.cls-11{stroke-width:2.23px;}.cls-12{stroke-width:0.65px;}.cls-13{fill:#fdfefe;}.cls-14,.cls-22{stroke:#fff;}.cls-14{stroke-width:0.96px;}.cls-15{opacity:0.5;}.cls-16{clip-path:url(#clip-path-2);}.cls-17{fill:#e5ac24;}.cls-18{stroke:#4f4e4f;stroke-width:1.23px;}.cls-19{clip-path:url(#clip-path-3);}.cls-20{fill:#eae6e1;}.cls-21{clip-path:url(#clip-path-4);}.cls-22{stroke-width:1.28px;}.cls-23{fill:#cd922a;}.cls-24,.cls-25{stroke:#e5ac24;}.cls-24{stroke-width:2px;}.cls-25{stroke-width:1.71px;}.cls-26{fill:#e0e0e0;}.cls-27{mix-blend-mode:darken;font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-28{fill:#f7a7a8;}.cls-29{fill:#263238;}.cls-30{fill:#fec536;}.cls-31,.cls-34,.cls-35,.cls-41{fill:#2e1f42;}.cls-32{fill:#ebebeb;}.cls-33{fill:#ab6cad;}.cls-34{opacity:0.4;}.cls-35,.cls-36{opacity:0.3;}.cls-37{fill:#f1f0f0;}.cls-38{fill:#f3908f;}.cls-39{fill:#fafbfb;}.cls-40{fill:#b16669;}.cls-41{opacity:0.15;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 527.59,
    y: 94.1,
    width: 4.16,
    height: 2.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1193.55,
    y: 207.27,
    width: 51.48,
    height: 58.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1201.51,
    y: 211.7,
    width: 12.54,
    height: 11.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1198.99,
    y: 210.02,
    width: 17.58,
    height: 16.52
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "brand postioning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 1600,
    height: 326
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M527.72,96.33a3.23,3.23,0,0,0,3.9-2.1"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1382.6,185.6a7.82,7.82,0,1,1-7.81-7.82,7.82,7.82,0,0,1,7.81,7.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1409.74,215.85a7.82,7.82,0,1,1-7.82-7.82,7.82,7.82,0,0,1,7.82,7.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1413.57,168.33a7.82,7.82,0,1,1-4.54-10.08,7.82,7.82,0,0,1,4.54,10.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1381.41,
    y1: 181.47,
    x2: 1399.82,
    y2: 169.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1377.26,
    y1: 193.01,
    x2: 1396.46,
    y2: 211.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.89,195.65a5.51,5.51,0,1,1,1.71,7.6,5.5,5.5,0,0,1-1.71-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90.12,167.42a5.51,5.51,0,1,1,1.71,7.6,5.5,5.5,0,0,1-1.71-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.94,194.28A5.51,5.51,0,1,1,68.85,202a5.52,5.52,0,0,1,1.09-7.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 94.04,
    y1: 198.56,
    x2: 78.71,
    y2: 198.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 100.86,
    y1: 193.25,
    x2: 96.36,
    y2: 175.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M530.1,124.47A61.37,61.37,0,1,1,468.74,63.1a61.36,61.36,0,0,1,61.36,61.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M525,124.47a56.21,56.21,0,1,1-56.21-56.21A56.21,56.21,0,0,1,525,124.47"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 468.74,
    cy: 124.47,
    r: 37.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M487.05,124.47a18.31,18.31,0,1,1-18.31-18.31,18.31,18.31,0,0,1,18.31,18.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M482.18,124.6a13.44,13.44,0,1,1-13.44-13.44,13.44,13.44,0,0,1,13.44,13.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "480.13 120.68 482.35 127.55 475.29 126.04 468.22 124.53 473.06 119.17 477.9 113.8 480.13 120.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 480.13,
    y1: 120.68,
    x2: 566.57,
    y2: 92.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "582.68 92.36 568.27 97.02 564.49 93.36 565.41 88.17 579.82 83.5 579.33 88.55 582.68 92.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1471.21,
    y: 24.41,
    width: 61.39,
    height: 88.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1479.61,
    y1: 47.84,
    x2: 1511.29,
    y2: 47.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1479.61,
    y1: 55.96,
    x2: 1511.29,
    y2: 55.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1479.61,
    y1: 64.07,
    x2: 1511.29,
    y2: 64.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1479.61,
    y1: 72.19,
    x2: 1511.29,
    y2: 72.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1479.61,
    y1: 80.31,
    x2: 1511.29,
    y2: 80.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1479.61,
    y1: 88.43,
    x2: 1511.29,
    y2: 88.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1479.61,
    y1: 96.55,
    x2: 1511.29,
    y2: 96.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1479.61,
    y1: 104.66,
    x2: 1511.29,
    y2: 104.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1514.33,
    y: 29.07,
    width: 14.04,
    height: 14.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M112.64,70.41h0a26.26,26.26,0,0,0-.28-8.17h0L116,57.17l-2.56-5.67-6.25-.58,0,0a26.29,26.29,0,0,0-6-5.58l0,0-1-6.2L94.42,37l-4.83,4V41a26.34,26.34,0,0,0-8.18.28v0l-5.08-3.69-5.67,2.57-.58,6.25,0,0a26.24,26.24,0,0,0-5.58,6l0,0-6.2,1L56.15,59.2l4,4.83h.05a26.26,26.26,0,0,0,.28,8.17h0l-3.69,5.08,2.56,5.67,6.26.58,0,0a26.24,26.24,0,0,0,6,5.58h0l1,6.21,5.81,2.19,4.84-4v0a26.28,26.28,0,0,0,8.17-.28v0l5.08,3.69,5.66-2.57L102.7,88l0,0a26.06,26.06,0,0,0,5.59-6v0l6.21-1,2.19-5.82Zm-6.39,4.33A21.23,21.23,0,1,1,93.92,47.37a21.24,21.24,0,0,1,12.33,27.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1534.06,248.23h-45.54a4.41,4.41,0,0,0-4.42,4.41V274a4.42,4.42,0,0,0,4.42,4.42h3.73c.27,1.43.44,5.3-4.67,8,0,0,13.4-.64,13.59-8h32.89a4.41,4.41,0,0,0,4.41-4.42V252.64a4.4,4.4,0,0,0-4.41-4.41"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 1492.32,
    y1: 256.16,
    x2: 1530.23,
    y2: 256.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 1492.32,
    y1: 263.11,
    x2: 1530.23,
    y2: 263.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 1492.32,
    y1: 270.72,
    x2: 1530.23,
    y2: 270.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1245,233c0,2.36.12,9.06-4.14,14-2.33,2.71-4.66,3.41-7.08,7.32s-1.33,5.37-3.17,7.56c-4.33,5.14-16.77,4.86-21.46-.73-1.86-2.22-1.14-3.63-3.91-7.32-2.59-3.47-4.71-4.2-6.83-6.34-4.86-4.93-4.87-12.44-4.88-14.52,0-11.13,10-25.73,25.74-25.73S1244.88,222,1245,233"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1245,233c0,2.36.12,9.06-4.14,14-2.33,2.71-4.66,3.41-7.08,7.32s-1.33,5.37-3.17,7.56c-4.33,5.14-16.77,4.86-21.46-.73-1.86-2.22-1.14-3.63-3.91-7.32-2.59-3.47-4.71-4.2-6.83-6.34-4.86-4.93-4.87-12.44-4.88-14.52,0-11.13,10-25.73,25.74-25.73S1244.88,222,1245,233"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1229.16,265.58h-18.45a3.42,3.42,0,0,1,0-6.84h18.45a3.42,3.42,0,0,1,0,6.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1229.79,274.83h-18.73a3.29,3.29,0,0,1,0-6.57h18.73a3.29,3.29,0,0,1,0,6.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1229.29,284.35h-17.73a3.78,3.78,0,1,1,0-7.56h17.73a3.78,3.78,0,0,1,0,7.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1216.2,258.74s1.45-13.25-.64-17.26-5.1,3.17-2.09,3.53,5.4-1.28,7-3.69-2.39-5.95-2-1.77,5.62,3.85,7.23,4,.32-7.38-1.45-4.33-.32,4.5.48,6.9.32,12.61.32,12.61"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1213.36,212.68c1.58,1.8.36,5.45-2.72,8.17s-6.86,3.45-8.44,1.65-.37-5.45,2.71-8.16,6.86-3.46,8.45-1.66"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1215.6,211.4c2.21,2.52.51,7.64-3.81,11.44s-9.61,4.84-11.83,2.32-.52-7.64,3.8-11.44,9.62-4.84,11.84-2.32"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1225.79,292.7h-9.52a4.08,4.08,0,0,1-4.07-4.07v-1.81a4.08,4.08,0,0,1,4.07-4.07h9.52a4.08,4.08,0,0,1,4.07,4.07v1.81a4.08,4.08,0,0,1-4.07,4.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1242.39,
    y1: 207.39,
    x2: 1252.37,
    y2: 200.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1223.58,
    y1: 203.04,
    x2: 1223.58,
    y2: 190.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1206.96,
    y1: 204.83,
    x2: 1201.28,
    y2: 193.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1194.64,
    y1: 215.2,
    x2: 1183.96,
    y2: 209.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1189.71,
    y1: 229.14,
    x2: 1177.38,
    y2: 229.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1190.96,
    y1: 243.21,
    x2: 1180.04,
    y2: 248.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1247.55,
    y1: 223.6,
    x2: 1259.87,
    y2: 224.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1249.27,
    y1: 240.27,
    x2: 1260.47,
    y2: 245.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1218.92 40.27 1315.49 78.54 1268.05 108.16 1218.92 40.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "1218.92 40.27 1291.43 93.8 1291.43 112.92 1300.83 90.14 1218.92 40.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1280.64 98 1291.43 112.92 1291.43 93.8 1280.64 98"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 1074.87,
    cy: 55.96,
    r: 14.69,
    transform: "translate(847.47 1107.99) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-25",
    points: "26.84 290.16 43.84 302.05 51.38 282.71 68.39 294.61 75.92 275.27 92.94 287.16"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow",
    className: "cls-26",
    cx: 205.92,
    cy: 238.33,
    rx: 50.85,
    ry: 29.36
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-27",
    transform: "translate(688 152.92) scale(1 1.03)"
  }, "BRAND ", /*#__PURE__*/React.createElement("tspan", {
    x: -95.16,
    y: 72.82
  }, "POSITIONING")), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M283.69,255.6,294,235.27l20.77,12.15-25.6,30.23s-12.69-1.18-14.74-7.8S280.2,257.8,283.69,255.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M269.06,263.58a10.78,10.78,0,0,0-2.88,3.14c-.83,1.24-.58,7.26-1.37,10.06s-1.42,3.53-2.75,7c-1.48,3.88-4.22,7.42-1.13,17.39s8,14.73,12.22,17.16a11,11,0,0,0,5,1.22s5.47-2.07,4.63-5.3S269.06,263.58,269.06,263.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M293.08,274.52c-.15,1-1.59,2.61-2.17,3.45-2,2.82-2.87,6.63-3.55,10-3.23,15.78,3.05,23.8-5.45,29.72-2.46,1.55-7.56,1.12-15.32-8.82-4-5.08-6.22-15.53-4.68-20.26s3.67-7.81,4.66-11.45.48-10.42,2.49-13.54a14.62,14.62,0,0,1,4.93-4.24c1.5-.91,4.8-2.12,6.33-3s2.38-1.87,3.37-.75l-1.77,2.19c-2.77,3.83-2,4.39-1.93,6.43s-.64,4.38-1,6.5c2-2.49,2.77-4.66,4.92-4.28s2.41.28,5.49,3.17S293.22,273.61,293.08,274.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M266.59,308.83c-4-5.08-6.22-15.53-4.68-20.26a45.53,45.53,0,0,1,1.82-4.58c-.06.32-.16.65-.2.92-.1.61-.18,1.22-.24,1.84a14.29,14.29,0,0,0,.79,7.16c.89,2,2.95,6.9,5.61,7,1.5.06,2.77-1.41,3.35-3.09.24-.71.65-2.62.65-2.62a23.3,23.3,0,0,1,6.9,2.81c3.85,2.55,3.71,3.11,3.71,3.11a10.21,10.21,0,0,0-.13,3.38,8.31,8.31,0,0,0,1.44,3.37,5.15,5.15,0,0,0,1,.79c-.16,3.64-1.11,6.5-4.68,9C279.45,319.2,274.35,318.77,266.59,308.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M287.36,287.93a53.56,53.56,0,0,0-1,12.62c-1.45,4-2.72,3.92-2.9,1.82s2.62-10.78,4.7-18C287.86,285.6,287.6,286.8,287.36,287.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M277.76,262.64a8.78,8.78,0,0,1,1.55-5.78c.38-.18.73-.35,1-.51,1.66-1,2.38-1.87,3.37-.75l-1.77,2.19c-2.77,3.83-2,4.39-1.93,6.43s-.64,4.38-1,6.5c-1.61,6.85-3.08,9.14-3.83,15.61s.53,10.82-.38,11.18-2.76-.36-3.1-5.55,2-13.9,3.57-18S278.09,265.4,277.76,262.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M273.23,295.66a.63.63,0,0,0,.33.18c4.54.93,7,2.08,10.34,6.06a.66.66,0,0,0,.91.07.65.65,0,0,0,.08-.91c-3.58-4.2-6.24-5.49-11.07-6.49a.65.65,0,0,0-.76.51A.62.62,0,0,0,273.23,295.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M274.05,290.26a.6.6,0,0,0,.32.18c4.7,1.09,7.31,2.42,10.9,6.62a.64.64,0,0,0,.93.07.65.65,0,0,0,.07-.93c-3.78-4.42-6.62-5.89-11.6-7.05a.67.67,0,0,0-.8.5A.64.64,0,0,0,274.05,290.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M273.93,284.32a.8.8,0,0,0,.36.2c5.18,1.2,8.22,2.81,12.18,7.43a.73.73,0,0,0,1.11-.95c-4.17-4.86-7.47-6.63-13-7.9a.73.73,0,0,0-.69,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M274.79,279.24a.69.69,0,0,0,.35.2c5.08,1.17,8,2.72,11.91,7.26a.73.73,0,0,0,1,.08.71.71,0,0,0,.08-1c-4.08-4.77-7.29-6.48-12.68-7.73a.72.72,0,0,0-.67,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M276.66,274.3a.7.7,0,0,0,.35.19c5.08,1.18,8,2.72,11.91,7.27a.72.72,0,0,0,1.08-.94c-4.08-4.77-7.29-6.47-12.67-7.72a.71.71,0,0,0-.86.54A.7.7,0,0,0,276.66,274.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "289.3 257.22 302.74 268.22 310.35 272.99 301.67 289.4 277.2 277.69 289.3 257.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M261.89,183.81s48.95-8.11,69.89-8c21.37.13,23.35,16.18,18,26-10.24,18.81-45.85,58.72-45.85,58.72s-11.95-5.47-15.63-15.82l8.12-18.62-25.55,8.17-13.05-8.75-1.06-6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M261.89,183.81s48.95-8.11,69.89-8c21.37.13,23.35,16.18,18,26-10.24,18.81-45.85,58.72-45.85,58.72s-11.95-5.47-15.63-15.82l8.12-18.62-25.55,8.17-13.05-8.75-1.06-6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M261.89,183.81l-84.72,14.11s-.83,20.27,7.14,38.44a41.4,41.4,0,0,0,31.7,24.2,237.07,237.07,0,0,0,25.63,2.09A64.15,64.15,0,0,0,255,270.53c6.74,2.67,36.25,15,36.25,15s8.29-7,7.46-21.64l-27.86-29.64c-6.3-7.68-8.52-10.16-12-11.9C264.24,212,262.5,195.25,261.89,183.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M261.89,183.81l-84.72,14.11s-.83,20.27,7.14,38.44a41.4,41.4,0,0,0,31.7,24.2,237.07,237.07,0,0,0,25.63,2.09A64.15,64.15,0,0,0,255,270.53c6.74,2.67,36.25,15,36.25,15s8.29-7,7.46-21.64l-27.86-29.64c-6.3-7.68-8.52-10.16-12-11.9C264.24,212,262.5,195.25,261.89,183.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M300.7,210.26a182.22,182.22,0,0,0-10.79,17.94l6.52-2.08c7.36-17.53,8.87-22.64,20.63-30.86C317.06,195.26,308.63,198.44,300.7,210.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M235.39,252.82s-.1,4.3,6.25,9.83A64.15,64.15,0,0,0,255,270.53c6.74,2.67,36.25,15,36.25,15s1.6-.75,3.9-5.09c-7.63-1.8-32.76-11.63-40.88-15.07C239.85,259.29,235.39,252.82,235.39,252.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M266.67,229.33c2.85,3.34,4.21,5,4.21,5L275,233s-7.25-7.89-11.93-12a15.81,15.81,0,0,0-2.68-2.11c2.36-6.19,2.28-16.36,2.28-16.36a32.79,32.79,0,0,1-6.18,14.87c-3.27-.91-7.06-.92-11.76-.13-8.21,1.36-32,5.41-32,5.41s22.77-2,34.62-2.51S263.81,226,266.67,229.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M341.18,281.54c5.75,2.27,9.31,4.55,12,8s3.47,7,.94,11.2-7.17,9.16-12.68,8.84-8.9-1.7-14-4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M295.18,286.41c-.09,1.72,7.19,5.16,14.74,8.77,8.1,3.86,10.09,6.38,16.7,9.63,7.55,3.71,10.42,3.93,16.28,2.3s13.09-10,8.06-17.73c-4.11-6.29-9.43-8-17.5-10.14a155.24,155.24,0,0,1-18.88-6.1c-5.83-2.27-10.63-6.34-11.84-4.92.83.4,6.93,4.16,5.78,5.19-.28.52-1.15.36-2.65-.26a2.51,2.51,0,0,0-2.09-.1,4,4,0,0,0-1.51,1.81,44.1,44.1,0,0,0-1.83,4.63c-.45,1.06-.26.44-.68,1.52s-1.37,3-1.25,4.13c.07.67.55.88,1.06,1.2s1.24.72,1.72,1.09c.2.15.54.65.43.9-.18.42-1.23.22-1.67,0s-1.17-.36-1.71-.56S296.51,287,295.18,286.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M324,303.56c1.08.54,7.94,3.73,10.09,1.82C336.45,303.31,331,300,331,300s-.84-5.17,5.4-12.78c1.08.84,5.59.8,5.53-1.85s-7.62-5.91-7.73-6c7.73,2.07,12.82,3.85,16.81,10,5,7.71-2.2,16.1-8.06,17.73s-8.73,1.41-16.28-2.3C325.86,304.44,324.69,304,324,303.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M331.69,299.49c2.85,1,.89,3.56-3.29,2.72-6.28-1.27-11.49-4.83-18.48-7-7.55-3.61-15.25-7-14.75-8.87,1.35.51,4.24,1.71,4.24,1.71.57.24,2,.78,2,.78,5.72,2.48,12.05,6.45,18.25,8.13C325.14,298.41,328.83,298.54,331.69,299.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M335.94,288.21c-2.62-1.51-3.08-2.8-8.21-5.16s-13.81-7.4-19.17-10.53a70.49,70.49,0,0,1-5.82-4.3c.89-1,4.16-.08,7.43,2s5.26,3.38,8.51,5.07c6.3,3.78,13.48,6.33,17.08,8.65S338.55,289.73,335.94,288.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M336.32,287.52a.65.65,0,0,1-.15.23,23,23,0,0,0-4.89,12.67.75.75,0,0,1-.72.7.62.62,0,0,1-.58-.73c.8-8.67,5.09-13.37,5.33-13.63a.61.61,0,0,1,.92,0A.75.75,0,0,1,336.32,287.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M331.25,283.81a.77.77,0,0,1-.14.21,31.43,31.43,0,0,0-6.06,15,.75.75,0,0,1-.73.68.63.63,0,0,1-.56-.75,32.34,32.34,0,0,1,6.45-15.84.63.63,0,0,1,.93-.06A.75.75,0,0,1,331.25,283.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M320.07,298.44a.74.74,0,0,1-.61.46.62.62,0,0,1-.63-.68c.3-9.17,6.21-17.78,6.49-18.07a.6.6,0,0,1,.92,0,.79.79,0,0,1-.06,1c-.06.07-5.77,8.48-6,17A.94.94,0,0,1,320.07,298.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M315.37,295.45a.74.74,0,0,1-.59.45.61.61,0,0,1-.64-.67A27.08,27.08,0,0,1,321,278.08a.61.61,0,0,1,.92,0,.8.8,0,0,1-.11,1,25.92,25.92,0,0,0-6.34,16A.71.71,0,0,1,315.37,295.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M309.29,292.87a.75.75,0,0,1-.59.46.62.62,0,0,1-.65-.66c0-9.54,6.75-16.92,7.05-17.22a.61.61,0,0,1,.92,0,.77.77,0,0,1-.09,1c-.07.07-6.54,7.21-6.57,16.07A.88.88,0,0,1,309.29,292.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M263,111.65c4.05,6,19.41,27,19.41,27s9.95-7.14,16.78-12.87,11.18-8.5,14.33-19.83c.8-2.86,3-6.08,4-7.8a24.53,24.53,0,0,0,3-8.39c.17-1.46,3.88-1,4.57,3.65.46,2.42-.33,4.81-.33,7.2,0,.74-.41,2.28.51,2.15,5.54-.8,9.63-7.1,16.26-11.56,2.4-1.6,8.53-3.26,9.83.21.11.84-.5,1.43-.73,2.18a1,1,0,0,0,0,.3,6.13,6.13,0,0,0,.11,1c.16.7.45,1.36.59,2.06a5.06,5.06,0,0,1-.37,3.16,12.83,12.83,0,0,0-1.1,2.23,7.92,7.92,0,0,1-.58,4.35,17.75,17.75,0,0,1-2.12,3.38A12.33,12.33,0,0,0,346,112.5a14.1,14.1,0,0,1-2.7,3.59,56.07,56.07,0,0,1-12.08,10.09c-2.05,1.19-4.22,2.19-6.15,3.58a18.07,18.07,0,0,0-3.83,3.63c-1.35,1.77-4.18,4.26-7.45,8.89a243.79,243.79,0,0,1-20.41,25.66c-8.45,9.3-13.4,5.63-25.33-5.86-14.66-14.13-22.51-22.26-22.51-22.26L242,93C250.66,95.86,258.92,105.61,263,111.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M324.56,106.77a15.84,15.84,0,0,1-4.1,13.61C325.52,119,327.57,112.47,324.56,106.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M237.52,91.51c8.14,1.38,14.47,4.59,24.71,18.14S282.37,138,282.37,138l9.7-6.5c-2.61,1.51-.44,11.88,3.77,17.1a19.9,19.9,0,0,0,9.47,6.58s-4.69,7.45-9.57,12c-5.2,4.84-7.56,6.59-11.14,6.59s-7.53-2.07-16.9-11-24.23-23.12-24.23-23.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M282.37,138c-4.35,4.81-7.42,13.21-7.11,17.54-1.83-5.06,0-13.69,5.51-19.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M300.79,161.29a16.51,16.51,0,0,1-3-.92,17,17,0,0,1-5.33-3.48A18.51,18.51,0,0,1,287,146.25c0-.21-.25-.14-.23,0a17,17,0,0,0,5.39,11.61,18.23,18.23,0,0,0,5.63,3.52,17.15,17.15,0,0,0,2.43.77c.19-.26.48-.6.69-.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M251.29,121.08c-1.14-22.76-6.28-29-17.82-30.31l-19.05-2c-5.65,1.16-25.1,7.35-31.65,9.63-4.21,1.46-6,10.42-6.93,24.44-.74,11.4-.85,21-.47,36.7.31,13.2.63,28.25,4.67,46.6,15.75,6,61.3.27,79.46-20.54-1.46-4.7-7.29-13.21-8.21-22.66C251.88,143.13,251.64,128.23,251.29,121.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M182.35,98.09l14.22-5s2.57,6,8.08,17.45,5.71,16.67,6.22,36.68,4.18,55.2,6.56,63.32c-8.82,1.23-16.46,14-39.11,10.05,0,0-4.76-23.18-5.5-62.67C172.44,137.45,172.33,103.87,182.35,98.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M210.08,129.29c-2.22-18-9.75-18.91-11.49-13-6.54-9.79-7.76-17.86-7.66-21.22,1.78-2.59,3.3-4.92,4-6a4.82,4.82,0,0,1,2.91-2.35l.12,4.94s.47,4.83,5.84,11.43C207.75,107.92,209.14,114.12,210.08,129.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M223,91.4c8.1,3.15,14,12.15,16,24.59s3.47,44.2,4.81,53.59,7.35,25.75,7.35,25.75,9.94-4.09,12.69-11.89c-4.57-6-8.82-14.26-9.61-22.09S254.17,128.58,253,119s-2.19-22.73-13.5-27.14c-4.88-1.9-16.36-2.65-16.36-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M239.86,123.17c-1.11-9.15-6.32-25.53-16.23-28.87a7.89,7.89,0,0,1-.59-2.9l.09-4.76a40.41,40.41,0,0,1,8.45,4.13c4.28,2.77,11.67,11.6,13.58,18.73C240.86,105.86,239.16,111.78,239.86,123.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M198.59,83.57c-1.54-6.26-8.33-12.4-11.57-17.71-3.13-5.12-5.07-9.13-5.13-14.16,0-3,1.54-7.13,3.68-8.14-.25.12-.76-5.27-.72-5.78a17.48,17.48,0,0,1,1.33-5.31A19.09,19.09,0,0,1,193.06,24c4.34-2.94,9.7-4,14.94-4.29s10.51-.05,15.71-.7,10.48-2.38,14.2-6.08c-.2.2.28,2.45.31,2.83.08,1.12.11,2.24.08,3.36,0,1.79.3,3.5-.34,5.21a13,13,0,0,0,5.15-5.21c.62,4.84,1.16,10.11-1.35,14.3a4.13,4.13,0,0,1,2.12,3,12.66,12.66,0,0,1-.76,7.91,18.67,18.67,0,0,1-4.73,6.47,32.52,32.52,0,0,1-12.22,6.71,87.88,87.88,0,0,1-13.75,2.86,1.48,1.48,0,0,0-.8.28,1.53,1.53,0,0,0-.34.56c-1.78,4.35-4.67,8.44-7,12.51q-2.77,4.83-5.57,9.66S198.58,83.54,198.59,83.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M190,73.77c4.58,2.47,7.47-.55,7.47-.55L198,94.36c3.86,8.79,18.71,12.39,26.55,11.83a25.71,25.71,0,0,0-.64-13.77l-.13-5.74a21.11,21.11,0,0,0,7.75-1.31A14.48,14.48,0,0,0,241,74.3c1.24-5.7,1-12.49.07-19.52-.23-1.74-.43-3.91-.49-5.66A29.61,29.61,0,0,0,238.52,40,24.72,24.72,0,0,0,234,32.53a1.76,1.76,0,0,0-.87-.63,1.41,1.41,0,0,0-.89.18c-1.49.7-2.42,2.18-3.65,3.27-2.56,2.28-6.29,2.71-9.71,2.46a31.62,31.62,0,0,1-10-2.41,1.75,1.75,0,0,0-1.25-.2,1.13,1.13,0,0,0-.64,1,3.31,3.31,0,0,0,.19,1.2c1.13,3.87,2.08,8.51.58,12.42a12.09,12.09,0,0,1-2.3,3.63c-.26.29-3,2.43-3,2.45.32,1.89.77,6.67-2.35,6.72-2.25,0-2.52-2.78-4.94-5.16s-7.82-2.81-9.74.94C182.73,63.61,185,71.06,190,73.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M223.78,86.68c-7.93-.58-12.81-1.75-18.32-6.14-4.34-3.45-6.13-11.16-6.13-11.16s0,8.74,4.11,13.58c2.7,3.16,8,6.82,20.4,7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M219.29,55A2.22,2.22,0,1,1,217,52.77,2.28,2.28,0,0,1,219.29,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M217.07,48.13,212.46,51a2.85,2.85,0,0,1,.91-3.84A2.64,2.64,0,0,1,217.07,48.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M238.1,49.26l-5.21-1.69a2.63,2.63,0,0,1,3.36-1.81A2.87,2.87,0,0,1,238.1,49.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M237.33,53.64a2.22,2.22,0,1,1-2.08-2.45A2.27,2.27,0,0,1,237.33,53.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M225.1,52.24c1.41,1.95,2.86,3.84,4.41,5.64A64.14,64.14,0,0,0,234.43,63l.68.63-.89.15c-2.32.37-4.64.68-7,.86,2.26-.68,4.54-1.25,6.83-1.74l-.21.77a33.06,33.06,0,0,1-5-5.21,29.87,29.87,0,0,1-2.05-3A26.48,26.48,0,0,1,225.1,52.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M218.34,69l9.37,1.6a4.67,4.67,0,0,1-5.38,4A5,5,0,0,1,218.34,69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M219.52,70.5a5.51,5.51,0,0,0-1.15.07,4.92,4.92,0,0,0,4,4.1,4.3,4.3,0,0,0,1.52,0A4.36,4.36,0,0,0,219.52,70.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arm-2",
    "data-name": "Arm"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laptop"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M315.44,224.63a14.09,14.09,0,0,0-2.28-2.68c-8.75-8.11-25.2-18.82-39.17-27.72l-63.58,36.71a.59.59,0,0,0,0,1l46.17,26.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M334.72,206v1a4.22,4.22,0,0,1-2.11,3.66l-73.92,42.67a4.13,4.13,0,0,1-2.1.56,4.3,4.3,0,0,1-2.13-.56l-40.29-23.19a4.23,4.23,0,0,1-2.1-3.66v-1.42h0v0a.52.52,0,0,0,.26.46l44.25,25.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M256.58,251.07v2.82a4.18,4.18,0,0,0,2.11-.57l73.92-42.67a4.21,4.21,0,0,0,2.11-3.66v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M334.72,206l-43.82-25.3a2.52,2.52,0,0,0-2.52,0l-76,43.9a.56.56,0,0,0,0,1l44.23,25.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "256.18 247.35 232.54 233.72 301.66 193.82 325.42 207.38 256.18 247.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "325.42 207.38 324.52 207.9 301.66 194.85 233.45 234.24 232.55 233.72 301.66 193.81 325.42 207.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "244.56 209.43 245 209.68 256.58 216.37 277.19 204.47 277.62 204.23 265.6 197.29 244.56 209.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "245 209.68 256.58 216.37 277.19 204.47 265.6 197.78 245 209.68"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arm-3",
    "data-name": "Arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M267.85,214.46c-3.71-3.67-9.09-8.77-13.61-10.27a26.8,26.8,0,0,0-3.18-1,35.08,35.08,0,0,0,4.65-.92,8.23,8.23,0,0,0,3.92-2.6c.39-.51.67-1.32.18-1.72a1.1,1.1,0,0,0-.65-.24c-3.38-.1-6.05-.63-9.13-.85a12.83,12.83,0,0,0-4.15.07c-1.26.35-2.51.71-3.75,1.14-5.62,1.95-10.94,1.43-18.69-2.13s-35.71-20.76-35.71-20.76L193.65,208l22.12,8.55h0l.23.09c1.77.67,3.36,2,7.58,3.34,5,1.54,11.42-.28,15.77-.51s11.73,1.78,15.77,3.42S264,218.28,266,219,271.55,218.14,267.85,214.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M249.19,200.81a15.16,15.16,0,0,0-6.16,1,33.37,33.37,0,0,1,8,1.39,35.08,35.08,0,0,0,4.65-.92,8.61,8.61,0,0,0,3.56-2.18C256.83,201.75,252.12,201.11,249.19,200.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M257.78,251.7a5,5,0,0,0,4.31-.33l73.59-42.49a5,5,0,0,0,2.43-3.5l8.06-48a5.55,5.55,0,0,0,.07-.82,5,5,0,0,0-1.48-3.56l-76.48,44.16a3.77,3.77,0,0,0-1.8,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M256.58,251.08l.51.29a7.32,7.32,0,0,0,.69.33l8.7-52a3.77,3.77,0,0,1,1.8-2.59L344.76,153a5.57,5.57,0,0,0-1-.77l-76.63,44.24a3.67,3.67,0,0,0-1.8,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M267.19,198.09l-1.18-.68a3.72,3.72,0,0,0-.7,1.6l-8.73,52.07.51.29a7.32,7.32,0,0,0,.69.33l8.7-52A3.9,3.9,0,0,1,267.19,198.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M299.22,207.35c.54-3.22,3.86-7.49,7.42-9.55s6-1.11,5.46,2.11-3.86,7.49-7.41,9.54S298.68,210.56,299.22,207.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M209.22,190.5c-11.79-8.54-21.49-15.31-21.49-15.31L191.1,139s2.54-17.92-1.49-28c-4.19-10.53-8.34-12-8.34-12s-6.82,2.41-11.39,6.4-6.74,13.27-7.84,26.36c-1,11.49-2.79,40.3-3.08,47-.36,8.53,0,15.39,9.07,19.51,9.52,4.36,38.1,14.12,38.1,14.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M182.35,98.09c-9.27,3-14,4.68-17.91,15.53s-3.78,30.79-5,46.77-2.08,26.41.48,31.45c1.4,2.77,4,5.31,13.14,8.78s18,6.6,18,6.6S192,193.1,202,183.6l-13.83-8.41s3.17-32.62,3.95-41.54S193.87,105.82,182.35,98.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M188.21,175.19c-5.41-2.55-16.16-.25-18.45,1.69,2.73-4.73,10-6.43,18.81-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M191.71,185a13.09,13.09,0,0,0-4,4.65,23.32,23.32,0,0,0-2.21,5.54,29.51,29.51,0,0,0-.93,6.74,28.55,28.55,0,0,0,0,2.92l1,.37a28.3,28.3,0,0,1,.81-9.69,24.24,24.24,0,0,1,2.13-5.42,53.39,53.39,0,0,1,3.25-4.86C191.87,185.19,191.85,184.93,191.71,185Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandpostioning);
export default __webpack_public_path__ + "static/media/brand postioning.662969ab998278319febdf422a220a8c.svg";
export { ForwardRef as ReactComponent };